/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as FinanceRouteImport } from './routes/finance'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as ChangelogRouteImport } from './routes/changelog'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminWebhooksRouteImport } from './routes/admin.webhooks'
import { Route as AdminSyncRouteImport } from './routes/admin.sync'
import { Route as AdminRepsRouteImport } from './routes/admin.reps'
import { Route as AdminReconcileRouteImport } from './routes/admin.reconcile'
import { Route as AdminProductsRouteImport } from './routes/admin.products'
import { Route as AdminPayoutsRouteImport } from './routes/admin.payouts'
import { Route as AdminLeaderboardRouteImport } from './routes/admin.leaderboard'
import { Route as AdminInvoicesRouteImport } from './routes/admin.invoices'
import { Route as AdminHealthRouteImport } from './routes/admin.health'
import { Route as AdminFxRouteImport } from './routes/admin.fx'
import { Route as AdminFunnelRouteImport } from './routes/admin.funnel'
import { Route as AdminDealsRouteImport } from './routes/admin.deals'
import { Route as AdminCustomersRouteImport } from './routes/admin.customers'
import { Route as AdminCommissionsRouteImport } from './routes/admin.commissions'
import { Route as AdminAuditRouteImport } from './routes/admin.audit'
import { Route as DashboardCommissionsIdRouteImport } from './routes/dashboard_.commissions.$id'
import { Route as AdminCommissionsIdRouteImport } from './routes/admin.commissions_.$id'
import { Route as AdminRepsIdStructuresRouteImport } from './routes/admin.reps_.$id.structures'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const FinanceRoute = FinanceRouteImport.update({
  id: '/finance',
  path: '/finance',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const ChangelogRoute = ChangelogRouteImport.update({
  id: '/changelog',
  path: '/changelog',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminWebhooksRoute = AdminWebhooksRouteImport.update({
  id: '/webhooks',
  path: '/webhooks',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSyncRoute = AdminSyncRouteImport.update({
  id: '/sync',
  path: '/sync',
  getParentRoute: () => AdminRoute,
} as any)
const AdminRepsRoute = AdminRepsRouteImport.update({
  id: '/reps',
  path: '/reps',
  getParentRoute: () => AdminRoute,
} as any)
const AdminReconcileRoute = AdminReconcileRouteImport.update({
  id: '/reconcile',
  path: '/reconcile',
  getParentRoute: () => AdminRoute,
} as any)
const AdminProductsRoute = AdminProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPayoutsRoute = AdminPayoutsRouteImport.update({
  id: '/payouts',
  path: '/payouts',
  getParentRoute: () => AdminRoute,
} as any)
const AdminLeaderboardRoute = AdminLeaderboardRouteImport.update({
  id: '/leaderboard',
  path: '/leaderboard',
  getParentRoute: () => AdminRoute,
} as any)
const AdminInvoicesRoute = AdminInvoicesRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => AdminRoute,
} as any)
const AdminHealthRoute = AdminHealthRouteImport.update({
  id: '/health',
  path: '/health',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFxRoute = AdminFxRouteImport.update({
  id: '/fx',
  path: '/fx',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFunnelRoute = AdminFunnelRouteImport.update({
  id: '/funnel',
  path: '/funnel',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDealsRoute = AdminDealsRouteImport.update({
  id: '/deals',
  path: '/deals',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCustomersRoute = AdminCustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCommissionsRoute = AdminCommissionsRouteImport.update({
  id: '/commissions',
  path: '/commissions',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAuditRoute = AdminAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AdminRoute,
} as any)
const DashboardCommissionsIdRoute = DashboardCommissionsIdRouteImport.update({
  id: '/dashboard_/commissions/$id',
  path: '/dashboard/commissions/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminCommissionsIdRoute = AdminCommissionsIdRouteImport.update({
  id: '/commissions_/$id',
  path: '/commissions/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminRepsIdStructuresRoute = AdminRepsIdStructuresRouteImport.update({
  id: '/reps_/$id/structures',
  path: '/reps/$id/structures',
  getParentRoute: () => AdminRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/changelog': typeof ChangelogRoute
  '/dashboard': typeof DashboardRoute
  '/finance': typeof FinanceRoute
  '/login': typeof LoginRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/commissions': typeof AdminCommissionsRoute
  '/admin/customers': typeof AdminCustomersRoute
  '/admin/deals': typeof AdminDealsRoute
  '/admin/funnel': typeof AdminFunnelRoute
  '/admin/fx': typeof AdminFxRoute
  '/admin/health': typeof AdminHealthRoute
  '/admin/invoices': typeof AdminInvoicesRoute
  '/admin/leaderboard': typeof AdminLeaderboardRoute
  '/admin/payouts': typeof AdminPayoutsRoute
  '/admin/products': typeof AdminProductsRoute
  '/admin/reconcile': typeof AdminReconcileRoute
  '/admin/reps': typeof AdminRepsRoute
  '/admin/sync': typeof AdminSyncRoute
  '/admin/webhooks': typeof AdminWebhooksRoute
  '/admin/': typeof AdminIndexRoute
  '/admin/commissions/$id': typeof AdminCommissionsIdRoute
  '/dashboard/commissions/$id': typeof DashboardCommissionsIdRoute
  '/admin/reps/$id/structures': typeof AdminRepsIdStructuresRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/changelog': typeof ChangelogRoute
  '/dashboard': typeof DashboardRoute
  '/finance': typeof FinanceRoute
  '/login': typeof LoginRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/commissions': typeof AdminCommissionsRoute
  '/admin/customers': typeof AdminCustomersRoute
  '/admin/deals': typeof AdminDealsRoute
  '/admin/funnel': typeof AdminFunnelRoute
  '/admin/fx': typeof AdminFxRoute
  '/admin/health': typeof AdminHealthRoute
  '/admin/invoices': typeof AdminInvoicesRoute
  '/admin/leaderboard': typeof AdminLeaderboardRoute
  '/admin/payouts': typeof AdminPayoutsRoute
  '/admin/products': typeof AdminProductsRoute
  '/admin/reconcile': typeof AdminReconcileRoute
  '/admin/reps': typeof AdminRepsRoute
  '/admin/sync': typeof AdminSyncRoute
  '/admin/webhooks': typeof AdminWebhooksRoute
  '/admin': typeof AdminIndexRoute
  '/admin/commissions/$id': typeof AdminCommissionsIdRoute
  '/dashboard/commissions/$id': typeof DashboardCommissionsIdRoute
  '/admin/reps/$id/structures': typeof AdminRepsIdStructuresRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/changelog': typeof ChangelogRoute
  '/dashboard': typeof DashboardRoute
  '/finance': typeof FinanceRoute
  '/login': typeof LoginRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/commissions': typeof AdminCommissionsRoute
  '/admin/customers': typeof AdminCustomersRoute
  '/admin/deals': typeof AdminDealsRoute
  '/admin/funnel': typeof AdminFunnelRoute
  '/admin/fx': typeof AdminFxRoute
  '/admin/health': typeof AdminHealthRoute
  '/admin/invoices': typeof AdminInvoicesRoute
  '/admin/leaderboard': typeof AdminLeaderboardRoute
  '/admin/payouts': typeof AdminPayoutsRoute
  '/admin/products': typeof AdminProductsRoute
  '/admin/reconcile': typeof AdminReconcileRoute
  '/admin/reps': typeof AdminRepsRoute
  '/admin/sync': typeof AdminSyncRoute
  '/admin/webhooks': typeof AdminWebhooksRoute
  '/admin/': typeof AdminIndexRoute
  '/admin/commissions_/$id': typeof AdminCommissionsIdRoute
  '/dashboard_/commissions/$id': typeof DashboardCommissionsIdRoute
  '/admin/reps_/$id/structures': typeof AdminRepsIdStructuresRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/changelog'
    | '/dashboard'
    | '/finance'
    | '/login'
    | '/admin/audit'
    | '/admin/commissions'
    | '/admin/customers'
    | '/admin/deals'
    | '/admin/funnel'
    | '/admin/fx'
    | '/admin/health'
    | '/admin/invoices'
    | '/admin/leaderboard'
    | '/admin/payouts'
    | '/admin/products'
    | '/admin/reconcile'
    | '/admin/reps'
    | '/admin/sync'
    | '/admin/webhooks'
    | '/admin/'
    | '/admin/commissions/$id'
    | '/dashboard/commissions/$id'
    | '/admin/reps/$id/structures'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/changelog'
    | '/dashboard'
    | '/finance'
    | '/login'
    | '/admin/audit'
    | '/admin/commissions'
    | '/admin/customers'
    | '/admin/deals'
    | '/admin/funnel'
    | '/admin/fx'
    | '/admin/health'
    | '/admin/invoices'
    | '/admin/leaderboard'
    | '/admin/payouts'
    | '/admin/products'
    | '/admin/reconcile'
    | '/admin/reps'
    | '/admin/sync'
    | '/admin/webhooks'
    | '/admin'
    | '/admin/commissions/$id'
    | '/dashboard/commissions/$id'
    | '/admin/reps/$id/structures'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/changelog'
    | '/dashboard'
    | '/finance'
    | '/login'
    | '/admin/audit'
    | '/admin/commissions'
    | '/admin/customers'
    | '/admin/deals'
    | '/admin/funnel'
    | '/admin/fx'
    | '/admin/health'
    | '/admin/invoices'
    | '/admin/leaderboard'
    | '/admin/payouts'
    | '/admin/products'
    | '/admin/reconcile'
    | '/admin/reps'
    | '/admin/sync'
    | '/admin/webhooks'
    | '/admin/'
    | '/admin/commissions_/$id'
    | '/dashboard_/commissions/$id'
    | '/admin/reps_/$id/structures'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  ChangelogRoute: typeof ChangelogRoute
  DashboardRoute: typeof DashboardRoute
  FinanceRoute: typeof FinanceRoute
  LoginRoute: typeof LoginRoute
  DashboardCommissionsIdRoute: typeof DashboardCommissionsIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/finance': {
      id: '/finance'
      path: '/finance'
      fullPath: '/finance'
      preLoaderRoute: typeof FinanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/changelog': {
      id: '/changelog'
      path: '/changelog'
      fullPath: '/changelog'
      preLoaderRoute: typeof ChangelogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/webhooks': {
      id: '/admin/webhooks'
      path: '/webhooks'
      fullPath: '/admin/webhooks'
      preLoaderRoute: typeof AdminWebhooksRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/sync': {
      id: '/admin/sync'
      path: '/sync'
      fullPath: '/admin/sync'
      preLoaderRoute: typeof AdminSyncRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/reps': {
      id: '/admin/reps'
      path: '/reps'
      fullPath: '/admin/reps'
      preLoaderRoute: typeof AdminRepsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/reconcile': {
      id: '/admin/reconcile'
      path: '/reconcile'
      fullPath: '/admin/reconcile'
      preLoaderRoute: typeof AdminReconcileRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/products': {
      id: '/admin/products'
      path: '/products'
      fullPath: '/admin/products'
      preLoaderRoute: typeof AdminProductsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/payouts': {
      id: '/admin/payouts'
      path: '/payouts'
      fullPath: '/admin/payouts'
      preLoaderRoute: typeof AdminPayoutsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/leaderboard': {
      id: '/admin/leaderboard'
      path: '/leaderboard'
      fullPath: '/admin/leaderboard'
      preLoaderRoute: typeof AdminLeaderboardRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/invoices': {
      id: '/admin/invoices'
      path: '/invoices'
      fullPath: '/admin/invoices'
      preLoaderRoute: typeof AdminInvoicesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/health': {
      id: '/admin/health'
      path: '/health'
      fullPath: '/admin/health'
      preLoaderRoute: typeof AdminHealthRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/fx': {
      id: '/admin/fx'
      path: '/fx'
      fullPath: '/admin/fx'
      preLoaderRoute: typeof AdminFxRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/funnel': {
      id: '/admin/funnel'
      path: '/funnel'
      fullPath: '/admin/funnel'
      preLoaderRoute: typeof AdminFunnelRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/deals': {
      id: '/admin/deals'
      path: '/deals'
      fullPath: '/admin/deals'
      preLoaderRoute: typeof AdminDealsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/customers': {
      id: '/admin/customers'
      path: '/customers'
      fullPath: '/admin/customers'
      preLoaderRoute: typeof AdminCustomersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/commissions': {
      id: '/admin/commissions'
      path: '/commissions'
      fullPath: '/admin/commissions'
      preLoaderRoute: typeof AdminCommissionsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/audit': {
      id: '/admin/audit'
      path: '/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AdminAuditRouteImport
      parentRoute: typeof AdminRoute
    }
    '/dashboard_/commissions/$id': {
      id: '/dashboard_/commissions/$id'
      path: '/dashboard/commissions/$id'
      fullPath: '/dashboard/commissions/$id'
      preLoaderRoute: typeof DashboardCommissionsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/commissions_/$id': {
      id: '/admin/commissions_/$id'
      path: '/commissions/$id'
      fullPath: '/admin/commissions/$id'
      preLoaderRoute: typeof AdminCommissionsIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/reps_/$id/structures': {
      id: '/admin/reps_/$id/structures'
      path: '/reps/$id/structures'
      fullPath: '/admin/reps/$id/structures'
      preLoaderRoute: typeof AdminRepsIdStructuresRouteImport
      parentRoute: typeof AdminRoute
    }
  }
}

interface AdminRouteChildren {
  AdminAuditRoute: typeof AdminAuditRoute
  AdminCommissionsRoute: typeof AdminCommissionsRoute
  AdminCustomersRoute: typeof AdminCustomersRoute
  AdminDealsRoute: typeof AdminDealsRoute
  AdminFunnelRoute: typeof AdminFunnelRoute
  AdminFxRoute: typeof AdminFxRoute
  AdminHealthRoute: typeof AdminHealthRoute
  AdminInvoicesRoute: typeof AdminInvoicesRoute
  AdminLeaderboardRoute: typeof AdminLeaderboardRoute
  AdminPayoutsRoute: typeof AdminPayoutsRoute
  AdminProductsRoute: typeof AdminProductsRoute
  AdminReconcileRoute: typeof AdminReconcileRoute
  AdminRepsRoute: typeof AdminRepsRoute
  AdminSyncRoute: typeof AdminSyncRoute
  AdminWebhooksRoute: typeof AdminWebhooksRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminCommissionsIdRoute: typeof AdminCommissionsIdRoute
  AdminRepsIdStructuresRoute: typeof AdminRepsIdStructuresRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAuditRoute: AdminAuditRoute,
  AdminCommissionsRoute: AdminCommissionsRoute,
  AdminCustomersRoute: AdminCustomersRoute,
  AdminDealsRoute: AdminDealsRoute,
  AdminFunnelRoute: AdminFunnelRoute,
  AdminFxRoute: AdminFxRoute,
  AdminHealthRoute: AdminHealthRoute,
  AdminInvoicesRoute: AdminInvoicesRoute,
  AdminLeaderboardRoute: AdminLeaderboardRoute,
  AdminPayoutsRoute: AdminPayoutsRoute,
  AdminProductsRoute: AdminProductsRoute,
  AdminReconcileRoute: AdminReconcileRoute,
  AdminRepsRoute: AdminRepsRoute,
  AdminSyncRoute: AdminSyncRoute,
  AdminWebhooksRoute: AdminWebhooksRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminCommissionsIdRoute: AdminCommissionsIdRoute,
  AdminRepsIdStructuresRoute: AdminRepsIdStructuresRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  ChangelogRoute: ChangelogRoute,
  DashboardRoute: DashboardRoute,
  FinanceRoute: FinanceRoute,
  LoginRoute: LoginRoute,
  DashboardCommissionsIdRoute: DashboardCommissionsIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
